export default __webpack_public_path__ + "static/media/icon-new.80910995.svg";